import {
    CHANGE_DIRECTORIES_CHECKBOX,
    ERROR_MESSAGE,
    GET_DIRECTORIES,
    LOADER_DIRECTORIES, OPEN_ALERT_SUCCESS,
    OPEN_MODAL,
    SET_INDEX_ISSUINGAUTHORITY,
    SET_INDEX_SOATO,
    SET_INDEX_TERRORIST,
    SET_ISSUING_AUTHORITY_DIRECTORIES,
    SET_SOATO_DIRECTORIES,
    SET_TERRORIST_DIRECTORIES
} from "./actionTypes";

export const directories = (payload) => ({
    type: GET_DIRECTORIES,
    payload
})

export const setDirectoriesTerrorist = (payload) => ({
    type: SET_INDEX_TERRORIST,
    payload
})
export const setDirectoriesSoato = (payload) => ({
    type: SET_INDEX_SOATO,
    payload
})

export const setDirectoriesIssuingAuthority = (payload) => ({
    type: SET_INDEX_ISSUINGAUTHORITY,
    payload
})

export const openModal = (payload) => ({
    type: OPEN_MODAL,
    payload
})

export const errorMessages = (payload) => ({
    type: ERROR_MESSAGE,
    payload
})

export const errorMessage = (payload) => ({
    type: ERROR_MESSAGE,
    payload
})

export const changeDirectoriesChackBox = (payload) => ({
    type: CHANGE_DIRECTORIES_CHECKBOX,
    payload
})

export const setTerroristDirectory = (payload) => ({
    type: SET_TERRORIST_DIRECTORIES,
    payload
})

export const setSoatoDirectory = (payload) => ({
    type: SET_SOATO_DIRECTORIES,
    payload
})

export const setIssuingAuthorityDirectory = (payload) => ({
    type: SET_ISSUING_AUTHORITY_DIRECTORIES,
    payload
})

export const loaderDirectories = (payload) => ({
    type: LOADER_DIRECTORIES,
    payload
})

export const openAlertSuccess = () => ({
    type: OPEN_ALERT_SUCCESS
})
